import { takeLatest } from 'redux-saga/effects';

import { fetchSaga } from './helper';
import { fetchStaticRoutine } from '../routines';

function* watchFetchStaticSaga() {
  yield takeLatest(fetchStaticRoutine.TRIGGER, fetchSaga(fetchStaticRoutine, (payload) => `/v1/${payload.type}`));
}

export {
  watchFetchStaticSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/static.js